{
  "name": "Bitcoin",
  "description": "",
  "version": "0.0.1",
  "sources": {
    "module": {
      "checksum": "",
      "location": {
        "npm": {
          "filePath": "dist/index.js",
          "packageName": "@avalabs/bitcoin-module",
          "registry": "https://registry.npmjs.org"
        }
      }
    }
  },
  "network": {
    "chainIds": ["bip122:000000000019d6689c085ae165831e93", "bip122:000000000933ea01ad0ee984209779ba"],
    "namespaces": ["bip122"]
  },
  "cointype": "0",
  "permissions": {
    "rpc": {
      "dapps": true,
      "methods": ["bitcoin_sendTransaction", "bitcoin_signTransaction"],
      "nonRestrictedMethods": []
    }
  },
  "manifestVersion": "0.1"
}
